import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Card } from '../SubscriptionAppCard';
import { TrendIndicator } from '../TrendIndicator/TrendIndicator';
import type { QuarterSpend } from '../../data/mockContactSpending';
interface SpendingTrendStripProps {
  data: QuarterSpend[];
}
const formatCurrency = (value: number) => `$${value.toLocaleString('en-AU')}`;

// Slim collapsible strip matching the Membership journey strip; the takeaway shows even when collapsed
export function SpendingTrendStrip({
  data
}: SpendingTrendStripProps) {
  const [isOpen, setIsOpen] = useState(false);
  // Last 4 quarters vs the 4 before them
  const sum = (rows: QuarterSpend[]) => rows.reduce((total, row) => total + row.spend, 0);
  const previous = sum(data.slice(-8, -4));
  const recent = sum(data.slice(-4));
  const change = previous > 0 ? Math.round((recent - previous) / previous * 100) : 0;
  const direction = change >= 0 ? 'up' : 'down';
  return <Card padding="none" data-id="element-1719" data-mp="389ayhpdzlqzx">
      <div className={`px-6 py-3 ${isOpen ? 'border-b border-[#E2E8F0]' : 'rounded-lg'} bg-gradient-to-r from-[#F8FAFC] to-white`} data-id="element-1720" data-mp="3cd8uhr80mlor">
        <button type="button" onClick={() => setIsOpen(open => !open)} aria-expanded={isOpen} aria-controls="spending-trend-chart" className="flex flex-wrap items-center gap-2 text-left" data-id="element-1721" data-mp="2yc6adk0kzlgh">
          <ChevronDown className={`w-4 h-4 text-[#94A3B8] transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-1722" data-mp="2om3dv9u93pde" />
          <span className="text-sm font-semibold text-[#0F172A]" data-id="element-1723" data-mp="2tfft4td1ijth">Spending trend</span>
          <span className="text-[#CBD5E1]" aria-hidden="true" data-id="element-1724" data-mp="2fnj7971yt65j">·</span>
          <span className="text-sm font-medium text-[#475569]" data-id="element-1725" data-mp="2kl1fev85rhch">
            {direction === 'up' ? 'Buying more' : 'Buying less'}
          </span>
          <span className="text-[#CBD5E1]" aria-hidden="true" data-id="element-1726" data-mp="25otvzx4kqjy9">·</span>
          <TrendIndicator value={Math.abs(change)} direction={direction} label="vs previous 12 months" data-id="element-1727" data-mp="2ann234hj78oe" />
        </button>
      </div>

      {isOpen && <div id="spending-trend-chart" className="p-6 bg-white rounded-b-lg" data-id="element-1728" data-mp="1rkuw0a73kvso">
          <p className="text-xs text-[#64748B] mb-2" data-id="element-1729" data-mp="1mqgyo28vkeld">Spend per quarter, last 2 years</p>
          <div className="h-[240px] w-full" data-id="element-1730" data-mp="1htqhtcp8xeyw">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1731" data-mp="1hqma45cko13h">
              <BarChart data={data} margin={{
            top: 10,
            right: 10,
            left: 0,
            bottom: 5
          }} data-id="element-1732" data-mp="1cvf7z1yyb4go">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-1733" data-mp="25isx4dweqvq8" />
                <XAxis dataKey="quarter" axisLine={false} tickLine={false} tick={{
              fill: '#64748B',
              fontSize: 12
            }} dy={10} data-id="element-1734" data-mp="20jgbfwh9vup8" />
                <YAxis axisLine={false} tickLine={false} tick={{
              fill: '#64748B',
              fontSize: 12
            }} tickFormatter={formatCurrency} width={56} data-id="element-1735" data-mp="1vju1px0nkwl6" />
                <Tooltip cursor={{
              fill: '#F1F5F9'
            }} contentStyle={{
              backgroundColor: '#fff',
              border: '1px solid #E2E8F0',
              borderRadius: '8px'
            }} formatter={(value: number, _name: string, item: {
              payload?: QuarterSpend;
            }) => [`${formatCurrency(value)} · ${item.payload?.bottles ?? 0} bottles`, 'Spend']} data-id="element-1736" data-mp="k4f2emkz1smw" />
                <Bar dataKey="spend" fill="#0EA5E9" radius={[4, 4, 0, 0]} data-id="element-1737" data-mp="3aj0wrjz9fvs9" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>}
    </Card>;
}